import configs from '@/configs'
export const ENTRY_ROUTE_QUERY = 'entry=true'
export const RESET_DEBIT_CARD_PIN_ROUTE_QUERY = 'reset=true'

export const LINE_BANK_LOGO = {
  SMALL: 'img/common/bg_logo_44.png',
  LARGE: 'img/common/bg_logo_62.png',
}

export const ANOTHER_BANK_LOGO = {
  SMALL: 'img/common/bg_logo_bk_44.png',
  LARGE: 'img/common/bg_logo_bk_62.png',
}

export const PHONE_BANK_LOGO = {
  SMALL: 'img/common/bg_logo_phone_44.png',
  LARGE: 'img/common/bg_logo_phone_62.png',
}

export enum ROOT {
  SCHEDULE_PAYMENT = '/schedule-payment',
  BILL_PAYMENT = '/bill-payment',
  BILL_PAYMENT_V2 = '/bill-payment-v2',
  SUPPORT = '/support',
  DEBIT_CARD = '/debit-card',
  NOTICE = '/notice',
  NOTIFICATION = '/notification',
  /* TODO: remove referral-promotion */
  PROMOTION = '/promotion',
}

export const SCHEDULE_PAYMENT_ROUTES = {
  ROOT: `${ROOT.SCHEDULE_PAYMENT}`,
  DETAIL: `${ROOT.SCHEDULE_PAYMENT}/detail`,
  HISTORY: `${ROOT.SCHEDULE_PAYMENT}/history`,
  REDIRECTHISTORY: `${ROOT.SCHEDULE_PAYMENT}/history/redirect`,
  HISTORY_DETAIL: `${ROOT.SCHEDULE_PAYMENT}/history/detail`,
  REGISTER: `${ROOT.SCHEDULE_PAYMENT}/register`,
  SEND: `${ROOT.SCHEDULE_PAYMENT}/send`,
}

export const DEBIT_CARD_ROUTES = {
  ROOT: `${ROOT.DEBIT_CARD}`,
  DETAIL: `${ROOT.DEBIT_CARD}/detail`,
  LIST: `${ROOT.DEBIT_CARD}/list`,
  ISSUE: `${ROOT.DEBIT_CARD}/issue`,
  ACTIVATE: `${ROOT.DEBIT_CARD}/activate`,
  DELETE: `${ROOT.DEBIT_CARD}/delete`,
  HISTORY: `${ROOT.DEBIT_CARD}/history`,
  HISTORY_DETAIL: `${ROOT.DEBIT_CARD}/history/detail`,
  PIN_LOCKED: `${ROOT.DEBIT_CARD}/pin-locked`,
}

export const DEBIT_CARD_ISSUE_ROUTES = {
  DESIGN: `${DEBIT_CARD_ROUTES.ISSUE}/design`,
  DESIGN_V2: `${DEBIT_CARD_ROUTES.ISSUE}/designv2`,
  ACCOUNT: `${DEBIT_CARD_ROUTES.ISSUE}/account`,
  ADDRESS: `${DEBIT_CARD_ROUTES.ISSUE}/address`,
  CONFIRM: `${DEBIT_CARD_ROUTES.ISSUE}/confirm`,
}

export const BILL_PAYMENT_ROUTES = {
  ROOT: `${ROOT.BILL_PAYMENT}`,
  PRODUCT_GROUP: `${ROOT.BILL_PAYMENT}/product-group`,
  PRODUCT: `${ROOT.BILL_PAYMENT}/product`,
  AMOUNT: `${ROOT.BILL_PAYMENT}/amount`,
  RESULT: `${ROOT.BILL_PAYMENT}/result`,
  DISBURSED: `${ROOT.BILL_PAYMENT}/disbursed`,
}

export const NOTICE_ROUTES = {
  ROOT: `${ROOT.NOTICE}`,
  DETAIL: `${ROOT.NOTICE}/detail`,
}

export const SUPPORT_ROUTES = {
  ROOT: `${ROOT.SUPPORT}`,
}

export const NOTIFICATION_ROUTES = {
  ROOT: `${ROOT.NOTIFICATION}`,
}

export const PROMOTION_ROUTES = {
  ROOT: `${ROOT.PROMOTION}`,
  REFERRAL: `${ROOT.PROMOTION}/referral`,
  INVITE: `${ROOT.PROMOTION}/invite`,
  SENT: `${ROOT.PROMOTION}/result`,
  TERMS: `${ROOT.PROMOTION}/terms`,

  /* MGM Promotion */
  MGM: `${ROOT.PROMOTION}/mgm`,
  MGM_ERROR: `${ROOT.PROMOTION}/mgm/error`,
}

const NATIVE_ROOT = {
  TOP: `${configs.APP_SCHEME}top`,
  DEBIT_CARD: `${configs.APP_SCHEME}debit-card`,
  OPEN_ACCOUNT: `${configs.APP_SCHEME}open-account`,
  SAVING_ACCOUNT: `${configs.APP_SCHEME}saving-account`,
  SCHEDULE_PAYMENT: `${configs.APP_SCHEME}schedule-payment`,
  SETTING: `${configs.APP_SCHEME}setting`,
  TERM_ACCOUNT: `${configs.APP_SCHEME}term-account`,
  GENERAL: `${configs.APP_SCHEME}general`,
  OUTPUT: `${configs.APP_SCHEME}output`,
  INCOME: `${configs.APP_SCHEME}income`,
  DEPOSIT: `${configs.APP_SCHEME}deposit`,
  WEB_PAGE: `${configs.APP_SCHEME}web-page`,
}

export const TOP_NATIVE_ROUTES = {
  ROOT: `${NATIVE_ROOT.TOP}`,
  WEBROOT: `${NATIVE_ROOT.WEB_PAGE}`,
}

export const SETTING_NATIVE_ROUTES = {
  ROOT: `${NATIVE_ROOT.SETTING}`,
  NOTIFICATION: `${NATIVE_ROOT.SETTING}/notification`,
  REGISTRATION_CODE: `${NATIVE_ROOT.SETTING}/registrationcode`,
}

export const WEB_PAGE_NATIVE_ROTUES = {
  DEBIT_CARD_PROMOS: `${NATIVE_ROOT.WEB_PAGE}/APP_DEBIT_CARD_PROMO`,
  CHECK_LIMIT: `${NATIVE_ROOT.WEB_PAGE}/APP_CHECK_LIMIT`,
}

export enum LANDING_SCHEME_ROOT {
  DEBIT_CARD = '/debit-card',
  SCHEDULE_PAYMENT = '/schedule-transfer',
  BILL_PAYMENT = '/bill-payment',
}

export const DEBIT_CARD_LANDING_SCHEME = {
  ROOT: `${LANDING_SCHEME_ROOT.DEBIT_CARD}`,
  ISSUE: `${LANDING_SCHEME_ROOT.DEBIT_CARD}/issue/design`,
  DETAIL: `${LANDING_SCHEME_ROOT.DEBIT_CARD}/detail`,
  HISTORY: `${LANDING_SCHEME_ROOT.DEBIT_CARD}/history`,
  ACTIVATE: `${LANDING_SCHEME_ROOT.DEBIT_CARD}/activate`,
}

export const SCHEDULE_PAYMENT_LANDING_SCHEME = {
  ROOT: `${LANDING_SCHEME_ROOT.SCHEDULE_PAYMENT}`,
  DETAIL: `${LANDING_SCHEME_ROOT.SCHEDULE_PAYMENT}/detail`,
  HISTORY: `${LANDING_SCHEME_ROOT.SCHEDULE_PAYMENT}/histories`,
  HISTORY_DETAIL: `${LANDING_SCHEME_ROOT.SCHEDULE_PAYMENT}/history`,
  SEND: `${LANDING_SCHEME_ROOT.SCHEDULE_PAYMENT}/add`,
}

export const BILL_PAYMENT_LANDING_SCHEME = {
  ROOT: `${LANDING_SCHEME_ROOT.BILL_PAYMENT}`,
  PULSA: `${LANDING_SCHEME_ROOT.BILL_PAYMENT}/pulsa`,
  BILLS: `${LANDING_SCHEME_ROOT.BILL_PAYMENT}/bills/provider`,
  PRODUCT: `${LANDING_SCHEME_ROOT.BILL_PAYMENT}/product`,
  AMOUNT: `${LANDING_SCHEME_ROOT.BILL_PAYMENT}/request`,
}

export interface IServerResponse<T> {
  code: number
  message: string
  content: T
}

/**
  성공 - 1000
  General - 2xxx
  Auth - 3xxx
  Account - 4xxx
  Transfer - 5xxx
  Loan - 6xxx
  Debitcard - 7xxx
  Payment - 8xxx
  Server 및 외부 에러코드 - 9xxx
 */
export enum STATUS_CODE {
  SUCCESS = 1000,
  INVALID_PARAMETER = 2000,
  NO_DATA = 2002,
  EXIPIED_TOKEN = 3001,
  CUSTOMER_ALLOWED = 3004,
  NOTAVAILABLE_ACCOUNT = 8115,
  INSUFFICIENT_BALANCE = 5004,
  INVALID_ACCCOUNT_STATUS = 5008,
  NO_SCHED_TRNS_DATA = 5013,
  MAXIMUM_FAVORITE_COUNT_OVER = 5201,
  INVALID_RECENTLY_FAVORITE_ACCOUNT_NO = 5900,
  EXPIRED_ACTIVATION = 7003,
  INVALID_CARD_INFO = 7004,
  CANNOT_DELIVERY = 7511,
  BILL_PAYMENT_TRANSACTION_FAIL = 8104,
  BILL_PAYMENT_TRANSACTION_TOO_MANY_UNPAID_BILLS = 8105,
  BILL_PAYMENT_TRANSACTION_ALREADY_PAID = 8106,
  BILL_PAYMENT_LIMIT_FOR_ONE_DAY = 8107,
  BILL_PAYMENT_TRANSACTION_REFUSED = 8108,
  BILL_PAYMENT_ALREADY_PAID = 8109,
  BILL_PAYMENT_AUTO_FILLED_DATA_MODIFIED = 8110,
  BILL_PAYMENT_EXCEEDED_TRANSACTION_LIMIT = 8116,
  BILL_PAYMENT_EXCEED_ONE_DAY_TRANSACTION_LIMIT = 8117,
  BILL_PAYMENT_PAYMENT_FAILED = 8118,
  BILL_PAYMENT_EXCEED_PURCHASE_LIMIT_FOR_ONE_DAY = 8119,
  BILL_PAYMENT_TRANSACTION_PENDING = 8124,

  PHONE_NUMBER_NOT_MATCHED = 8901,
  PHONE_NUMBER_INVALID = 8902,
  HLI_BUSINESS_ERROR = 9100,
  UNINTENDED_EXCEPTION = 9900,
  CONNECTION_ERROR = 9902,
  MAINTENANCE = 9909,
  GENERAL_CLIENT_ERROR = 29999,
  TRANSFER_CLIENT_ERROR = 59999,
  DEBIT_CARD_CLIENT_ERROR = 79999,
  PAYMENT_CLIENT_ERROR = 89999,
  NETWORK_TIMEOUT_ERROR = 'ECONNABORTED',
  NETWORK_OFF = 'NETWORK_OFF',
  NETWORK_ERROR = 'NETWORK_ERROR',
  UNKNOWN_SERVER_ERROR = 'UNKNOWN_SERVER_ERROR',
  UNKNOWN_PATH_ERROR = 'UNKNOWN_PATH_ERROR',
  INVALID_RESPONSE_ERROR = 'INVALID_RESPONSE_ERROR',
  LOADING_FAILED = 'LOADING_FAILED',
  UNKNOWN_CLIENT_ERROR = 99999,
}

export const PaginationRowCnt = 10

export interface IPageInfoRequest {
  page: number
  rowCnt: number
}
export interface IPageInfoResponse {
  curPage: number
  totCnt?: number
  totPage: number
}

export enum OKSign {
  YES = 'Y',
  NO = 'N',
}

export enum OS {
  AOS = 'android',
  IOS = 'ios',
}

export enum LANGUAGE {
  IN = 'in_IN',
  EN = 'en_US',
  KO = 'ko_KR',
}

export enum LANGUAGE_OF_OS {
  IN = 'id_ID',
  EN = 'en_US',
  KO = 'ko_KR',
}

export const LANGUAGE_FOR_I18N = {
  [LANGUAGE_OF_OS.IN]: LANGUAGE.IN,
  [LANGUAGE_OF_OS.EN]: LANGUAGE.EN,
  [LANGUAGE_OF_OS.KO]: LANGUAGE.KO,
}

export interface IEmptyResponse {
  empty: string
}

export interface IMap<T> {
  [code: string]: T
}

export const STATUS_BAR_COLOR = {
  DEFAULT: '#FFFFFF',
  DIMMED: '#999999',
  DEBIT_CARD_HISTORY: '#24C875',
  DEBIT_CARD_HISTORY_DIMMED: '#157846',
  SCHEDULE_PAYMENT_REGISTER_LOADING: '#C0C0C0',
}

export enum LOG_EVENT_NAME {
  APP_DEBITCARD_APPLICATION_SUCCESS = 'app_debitcard_application_success',
  APP_DEBITCARD_ACTIVATION_START = 'app_debitcard_activation_start',
  APP_DEBITCARD_ACTIVATION_SUCCESS = 'app_debitcard_activation_success',
  APP_BILLPAYMENT_START = 'app_billpayment_start',
  APP_BILLPAYMENT_PAY = 'app_billpayment_pay',
  APP_BILLPAYMENT_SUCCESS = 'app_billpayment_success',
  APP_SUPPORT_CLICK = 'app_support_click',

  APP_QCREDIT_DISBURSAL_START = 'app_qcredit_disbursal_start',
  APP_QCREDIT_DISBURSAL_REQUEST = 'app_qcredit_disbursal_request',
  APP_QCREDIT_DISBURSAL_ENTERPIN = 'app_qcredit_disbursal_enterpin',
  APP_QCREDIT_DISBURSAL_SUCCESS = 'app_qcredit_disbursal_success',
}

export enum LOG_EVENT_DISBURSAL_VALUE {
  DISBURSAL_TYPE = 'billpay',
}

export const LOG_EVENT_VALUE = {
  BILL_PAYMENT: {
    START_TYPE: {
      PULSA: 'pulsa',
      TOPUP: 'topup',
      EWALLET: 'ewallet',
      BILLS: 'bills',
      FAVORITES: 'favorites',
      RECENTLY: 'recently',
    },
    BILL_TYPE: {
      PULSA: 'pulsa',
      TOPUP: 'topup',
      PHONE_BILL: 'phonebill',
      PLN_PRE: 'plnpre',
      PLN_POST: 'plnpost',
    },
  },
}
